interface AllergyFilterBarProps {
  filter: "all" | "safe" | "warnings";
  onChange: (filter: "all" | "safe" | "warnings") => void;
  totalCount: number;
  safeCount: number;
  warningCount: number;
}

const AllergyFilterBar = ({
  filter,
  onChange,
  totalCount,
  safeCount,
  warningCount,
}: AllergyFilterBarProps) => {
  const options: { key: "all" | "safe" | "warnings"; label: string; count: number }[] = [
    { key: "all", label: "All", count: totalCount },
    { key: "safe", label: "Safe", count: safeCount },
    { key: "warnings", label: "Warnings", count: warningCount },
  ];

  return (
    <div className="flex bg-gray-100 rounded-2xl p-1 mb-4">
      {options.map((opt) => {
        const isActive = filter === opt.key;
        return (
          <button
            key={opt.key}
            onClick={() => onChange(opt.key)}
            className={`flex-1 flex items-center justify-center gap-1.5 py-2 px-3 rounded-xl text-xs font-semibold transition-all duration-200 ${
              isActive
                ? opt.key === "warnings"
                  ? "bg-white text-red-600 shadow-sm"
                  : opt.key === "safe"
                  ? "bg-white text-green-600 shadow-sm"
                  : "bg-white text-foreground shadow-sm"
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            {opt.key === "safe" && "✓ "}
            {opt.key === "warnings" && "⚠️ "}
            {opt.label}
            <span className={`inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full text-[10px] font-bold ${
              isActive
                ? opt.key === "warnings"
                  ? "bg-red-100 text-red-700"
                  : opt.key === "safe"
                  ? "bg-green-100 text-green-700"
                  : "bg-gray-100 text-foreground"
                : "bg-gray-200/60 text-muted-foreground"
            }`}>
              {opt.count}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default AllergyFilterBar;
